import React from "react"
import Helmet from "react-helmet"
import palette from "../design/palette"
import Styles from "../design/styles"
import SEO from "../components/SEO"
import PageSidebar from "../components/PageSidebar"
import PageFooter from "../components/PageFooter"

interface DefaultLayoutProps {
  children: JSX.Element[] | JSX.Element
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => (
  <div id="default-layout">
    <SEO />

    <Helmet>
      <html lang="no" />
      <meta name="theme-color" content={palette.accent} />
      <link rel="icon" type="image/png" href="/img/bonum-logo.png" />
      <meta name="google-site-verification" content="GT85yZXrAFeWqDFu1n7VgmFWrBl_ygwK2Yz-MhQzJlY" />
    </Helmet>

    <Styles />

    <PageSidebar>
      <div style={{
        backgroundImage: "linear-gradient(-45deg, rgb(14, 16, 28), rgb(32, 12, 39), rgb(18, 30, 45))"
      }}>
        {children}
        <PageFooter />
      </div>
    </PageSidebar>
  </div>
)

export default DefaultLayout
